import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = window.matchMedia("(max-width: 750px)");

function useMobileViewportCheck(breakpoint = MOBILE_BREAKPOINT) {
  const [mobileViewport, setViewport] = useState(breakpoint.matches);
  useEffect(() => {
    const handleResize = () => setViewport(breakpoint.matches);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return mobileViewport;
}

export default useMobileViewportCheck;
